export default __webpack_public_path__ + "static/media/pin-off-white.d3ef0ae2.svg";